import { Grid } from "@mui/material";
import { useTipos } from "../../../context/SuperAdmin/OASContexts/TiposContext";
import { Spinner } from "../../../components/Loading/Spinner";
import HeaderTipos from "../../../components/Table/OAS/Tipos/HeaderTipos";
import DeleteTiposModal from "../../../components/Table/OAS/Tipos/DeleteTiposModal";
import CreateTiposModal from "../../../components/Table/OAS/Tipos/CreateTiposModal";
import EditTiposModal from "../../../components/Table/OAS/Tipos/EditTiposModal";
import TiposTable from "../../../components/Table/OAS/Tipos/TiposTable";

const TiposPage = () => {
  const { isLoadingTipos } = useTipos();

  if (isLoadingTipos) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Agregar o eliminar tipos */}
      <Grid item>
        <HeaderTipos />
      </Grid>

      {/* Tabla de tipos */}
      <Grid item>
        <TiposTable />
      </Grid>

      {/* Modal para confirmar eliminar tipos de la organización */}
      <Grid item>
        <DeleteTiposModal />
      </Grid>

      {/* Modal para crear un tipo en una organización */}
      <Grid item>
        <CreateTiposModal />
      </Grid>

      {/* Modal para editar un tipo en una organización */}
      <Grid item>
        <EditTiposModal />
      </Grid>
    </Grid>
  );
};

export default TiposPage;
